import * as React from "react";
import { Button } from "../..";
import Fade from "../../Utilities/Fade";
export const NavToggler = (props) => {
    return (React.createElement("div", { className: "navbar-toggler mr-auto navbar-expand-md", id: props.id },
        React.createElement(Fade, { remove: true, in: !props.isOpen, timeout: 150, className: "position-absolute" },
            React.createElement(Button, { onClick: props.onClick, "data-testid": props.testId, variant: "primary", outline: true, size: "lg" },
                React.createElement("i", { className: "fe fe-chevrons-right" }),
                React.createElement(Fade, { in: props.isOpen, timeout: 150, className: "position-absolute" },
                    React.createElement("i", { className: "fe fe-chevrons-left" })))),
        React.createElement(Fade, { remove: true, in: props.isOpen, timeout: 150, className: "position-absolute" },
            React.createElement(Button, { onClick: props.onClick, "data-testid": props.testId, variant: "primary", outline: true, size: "lg" },
                React.createElement("i", { className: "fe fe-chevrons-left" })))));
};
//# sourceMappingURL=NavToggler.js.map